var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "new-invoice",
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.onSubmit($event)
        }
      }
    },
    [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "modal", class: { "is-active": _vm.modal } }, [
          _c("div", { staticClass: "modal-background" }),
          _c(
            "div",
            { staticClass: "modal-content" },
            [
              _c(_vm.component, {
                tag: "Component",
                attrs: { limit: _vm.creditLimitNeeded, debt: _vm.customerDebt },
                on: {
                  close: function($event) {
                    return _vm.onCloseModal()
                  }
                }
              })
            ],
            1
          ),
          _c("button", {
            staticClass: "modal-close is-large",
            attrs: { "aria-label": "close" },
            on: { click: _vm.onCloseModal }
          })
        ]),
        _c("div", { staticClass: "columns is-multiline" }, [
          _c(
            "div",
            { staticClass: "column is-6" },
            [_c("Receiver", { attrs: { "is-loading": _vm.loading } })],
            1
          ),
          _c(
            "div",
            { staticClass: "column is-6" },
            [
              _c("VoucherDetails", {
                ref: "voucherDetailsComponent",
                attrs: { "is-loading": _vm.loading }
              })
            ],
            1
          )
        ])
      ]),
      _c(
        "div",
        { staticClass: "container" },
        [
          _c("Concepts", { attrs: { "is-loading": _vm.loading } }),
          _c("CfdisRelatedReplacement", {
            attrs: { "replacement-type": "replacementInvoice" }
          }),
          _c("Comments"),
          _c("div", { staticClass: "field is-grouped" }, [
            _c("p", { staticClass: "control" }, [
              _c(
                "button",
                {
                  staticClass: "button is-primary",
                  class: { "is-loading": _vm.loading },
                  attrs: { disabled: _vm.loading },
                  on: {
                    click: function($event) {
                      return _vm.setStamp(false)
                    }
                  }
                },
                [_vm._v("\n          Guardar\n        ")]
              )
            ]),
            _c("p", { staticClass: "control" }, [
              _c(
                "button",
                {
                  staticClass: "button is-success",
                  class: { "is-loading": _vm.loading },
                  attrs: { type: "submit", disabled: _vm.loading },
                  on: {
                    click: function($event) {
                      return _vm.setStamp(true)
                    }
                  }
                },
                [_vm._v("\n          Guardar y Timbrar\n        ")]
              )
            ]),
            _c(
              "p",
              { staticClass: "control" },
              [
                _c(
                  "RouterLink",
                  {
                    staticClass: "button is-danger",
                    class: { "is-loading": _vm.loading },
                    attrs: { disabled: _vm.loading, to: { name: "Home" } }
                  },
                  [_vm._v("\n          Cancelar\n        ")]
                )
              ],
              1
            )
          ]),
          _c("RouterView")
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }